import React, { Component } from 'react';

import {BrowserRouter as Router,Switch,Route,Link} from "react-router-dom";
import UsingDrive from './UsingDrive';
import ForBusiness from './ForBusiness';
import Help from './Help';
import Home from './Home';
import Download from './Download';

class DieuHuongURL extends Component {
  render() {
    return (
      
      <div>
        <Switch>
          <Route exact path="/">
            <Home/>
          </Route>
          <Route path="/usingdrive">
            <UsingDrive/>
          </Route>
          <Route path="/download">
            <Download/>
          </Route>
          <Route path="/forbusiness">
            <ForBusiness/>
          </Route>
          <Route path="/help">
            <Help/>
          </Route>

        </Switch>
      </div>
    
    );
  }
}

export default DieuHuongURL;